/**
 * Login consent popup.
 *
 * Guests accept Aydınlatma and Kullanım koşulları before login.
 * The popup opens before every login, including after logout and from checkout.
 * The click time stays in sessionStorage until that login succeeds.
 */
;(function () {
  var PENDING_KEY = 'login_consent_pending'
  var VISIT_KEY = 'login_consent_visit'
  var REPORTED_KEY = 'login_consent_reported'
  var LEGACY_COOKIE = 'login_consent'
  var LOCK_CLASS = 'login-consent-lock'
  var lockedScrollY = 0
  var flushing = false

  function lockPageScroll() {
    if (document.documentElement.classList.contains(LOCK_CLASS)) return
    lockedScrollY = window.scrollY || window.pageYOffset || 0
    document.body.style.top = -lockedScrollY + 'px'
    document.documentElement.classList.add(LOCK_CLASS)
  }

  function unlockPageScroll() {
    if (!document.documentElement.classList.contains(LOCK_CLASS)) return
    document.documentElement.classList.remove(LOCK_CLASS)
    document.body.style.top = ''
    window.scrollTo(0, lockedScrollY)
  }

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax'
  }

  function readStorage(key) {
    try {
      return window.sessionStorage.getItem(key)
    } catch (e) {
      return null
    }
  }

  function writeStorage(key, value) {
    try {
      window.sessionStorage.setItem(key, value)
    } catch (e) {}
  }

  function removeStorage(key) {
    try {
      window.sessionStorage.removeItem(key)
    } catch (e) {}
  }

  function readPending() {
    var raw = readStorage(PENDING_KEY)
    if (!raw) return null
    try {
      var data = JSON.parse(raw)
      if (!data || data.privacy_accepted !== true || data.terms_accepted !== true) return null
      if (!data.last_consented_at && !data.consented_at) return null
      return data
    } catch (e) {
      return null
    }
  }

  function clearVisitConsent() {
    removeStorage(PENDING_KEY)
    removeStorage(VISIT_KEY)
    removeStorage(REPORTED_KEY)
  }

  function readConfig() {
    var node = document.getElementById('LoginConsentConfig')
    if (!node) return null
    try {
      return JSON.parse(node.textContent)
    } catch (e) {
      return null
    }
  }

  function cameFromLogin() {
    var ref = document.referrer || ''
    return /customer_authentication\/login/i.test(ref) ||
      /\/account\/login/i.test(ref) ||
      /shopify\.com\/authentication/i.test(ref) ||
      /checkout\.shopify\.com/i.test(ref)
  }

  function afterLoginReturnPath() {
    try {
      var params = new URLSearchParams(window.location.search)
      var value = params.get('consent_saved_return')
      if (!value) return ''
      return safeReturnPath(value)
    } catch (e) {
      return ''
    }
  }

  function flushPending() {
    var config = readConfig()
    if (!config || !config.loggedIn || flushing || !config.saveUrl) return Promise.resolve()
    if (readStorage(REPORTED_KEY) === '1') return Promise.resolve()

    var pending = readPending()
    var payload = null

    if (pending) {
      payload = {
        customer_id: config.customerId,
        email: config.email,
        privacy_accepted: true,
        terms_accepted: true,
        last_consented_at: pending.last_consented_at || pending.consented_at,
        last_logged_in_at: new Date().toISOString(),
        source: 'login_popup',
        consent_missing: false
      }
    } else if (cameFromLogin()) {
      payload = {
        customer_id: config.customerId,
        email: config.email,
        consent_missing: true,
        source: 'login_without_popup',
        last_logged_in_at: new Date().toISOString()
      }
    }

    if (!payload) return Promise.resolve()

    flushing = true
    return fetch(config.saveUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (response.ok) {
        if (pending) removeStorage(PENDING_KEY)
        writeStorage(REPORTED_KEY, '1')
      }
    }).catch(function () {}).then(function () {
      flushing = false
    })
  }

  function safeReturnPath(value) {
    if (!value || value.charAt(0) !== '/' || value.charAt(1) === '/' || value.charAt(1) === '\\') return '/checkout'
    return value
  }

  function consentReturnPath() {
    try {
      var params = new URLSearchParams(window.location.search)
      if (params.get('open_login_consent') !== '1') return ''
      return safeReturnPath(params.get('return_to') || '/checkout')
    } catch (e) {
      return ''
    }
  }

  function isLogoutLink(link) {
    var href = link && link.getAttribute('href')
    if (!href) return false
    return /\/logout(?:[/?#]|$)/.test(href)
  }

  function bindLogout() {
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null
      if (!isLogoutLink(link)) return
      clearVisitConsent()
    }, true)
  }

  function normalizePath(pathname) {
    var path = pathname || '/'
    path = path.replace(/\/+$/, '')
    return path || '/'
  }

  function pathOf(href) {
    try {
      return new URL(href, window.location.origin)
    } catch (e) {
      return null
    }
  }

  function isLoginHref(href) {
    if (!href) return false
    return /customer_authentication\/login/i.test(href) ||
      /\/account\/login(?:[/?#]|$)/i.test(href) ||
      /shopify\.com\/authentication/i.test(href)
  }

  function isAccountEntry(url) {
    if (!url || url.origin !== window.location.origin) return false
    var path = normalizePath(url.pathname)
    return /\/account$/.test(path) || /\/account\/login$/.test(path) || /\/customer_authentication\/login$/.test(path)
  }

  function isHostedAccountPath(pathname) {
    var path = normalizePath(pathname)
    return /\/account$/.test(path) || /\/account\/login$/.test(path)
  }

  function authenticationUrl(destinationPath) {
    var destination = destinationPath || '/account'
    var bridge = '/pages/login-consent-return?consent_saved_return=' + encodeURIComponent(destination)
    return '/customer_authentication/login?return_to=' + encodeURIComponent(bridge)
  }

  function accountDestination(url) {
    var path = normalizePath(url.pathname)
    if (/\/account\/login$/.test(path)) {
      return url.pathname.replace(/\/login\/?$/, '') || '/account'
    }
    return url.pathname + url.search
  }

  function loginUrlFor(href) {
    if (!href) return ''
    var url = pathOf(href)
    if (!url) return authenticationUrl('/account')

    if (/\/customer_authentication\/login$/i.test(normalizePath(url.pathname))) {
      var returnTo = url.searchParams.get('return_to') || ''
      if (returnTo.indexOf('consent_saved_return=') !== -1) return url.pathname + url.search
      var returnUrl = returnTo ? pathOf(returnTo) : null
      var returnPath = returnUrl ? normalizePath(returnUrl.pathname) : ''
      if (returnPath && !isHostedAccountPath(returnPath)) return url.pathname + url.search
      if (returnUrl && isHostedAccountPath(returnUrl.pathname)) {
        return authenticationUrl(accountDestination(returnUrl))
      }
      return authenticationUrl('/account')
    }

    if (isHostedAccountPath(url.pathname)) return authenticationUrl(accountDestination(url))
    if (isLoginHref(href)) return authenticationUrl('/account')
    return url.pathname + url.search
  }

  class LoginConsentPopup extends HTMLElement {
    constructor() {
      super()
      this.onDocumentClick = this.onDocumentClick.bind(this)
      this.onKeyDown = this.onKeyDown.bind(this)
      this.onChange = this.onChange.bind(this)
      this.onConfirm = this.onConfirm.bind(this)
      this.onDismiss = this.onDismiss.bind(this)
      this.onSectionSelect = this.onSectionSelect.bind(this)
      this.onSectionDeselect = this.onSectionDeselect.bind(this)
      this.onRequired = this.onRequired.bind(this)
      this.onPolicyLinkClick = this.onPolicyLinkClick.bind(this)
    }

    connectedCallback() {
      var path = window.location.pathname
      if (path === '/challenge' || path === '/password') return

      this.sectionId = this.getAttribute('section-id')
      this.designMode = this.dataset.designMode === 'true'
      this.accountUrl = this.dataset.accountUrl || '/account'
      this.loginUrl = this.dataset.loginUrl || '/account/login'
      this.homeUrl = this.dataset.homeUrl || '/'
      this.pendingUrl = ''
      this.confirmed = false
      this.blockingLogin = false

      this.addEventListener('click', this.onPolicyLinkClick, true)

      this.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.addEventListener('change', this.onChange)
        this.bindReadFirst(input)
      }, this)

      var confirmBtn = this.querySelector('[data-login-consent-confirm]')
      if (confirmBtn) confirmBtn.addEventListener('click', this.onConfirm)
      this.querySelectorAll('[data-login-consent-dismiss]').forEach(function (node) {
        node.addEventListener('click', this.onDismiss)
      }, this)

      if (this.designMode) {
        document.addEventListener('shopify:section:select', this.onSectionSelect)
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect)
        return
      }

      document.addEventListener('login-consent:required', this.onRequired)
      document.addEventListener('click', this.onDocumentClick, true)

      var checkoutReturn = consentReturnPath()
      if (checkoutReturn) {
        this.pendingUrl = authenticationUrl(checkoutReturn)
        this.blockingLogin = true
        this.open()
        return
      }

      if (window.loginConsentReturnTo) {
        this.pendingUrl = '/customer_authentication/login?return_to=' + encodeURIComponent(window.loginConsentReturnTo)
        this.blockingLogin = true
        this.open()
        return
      }

      if (isAccountEntry(pathOf(window.location.href)) && /\/(?:account\/login|customer_authentication\/login)$/.test(normalizePath(path))) {
        this.pendingUrl = loginUrlFor(window.location.href)
        this.blockingLogin = true
        this.open()
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick, true)
      document.removeEventListener('keydown', this.onKeyDown)
      document.removeEventListener('shopify:section:select', this.onSectionSelect)
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect)
      document.removeEventListener('login-consent:required', this.onRequired)
      this.close()
    }

    hasRequired() {
      var required = this.querySelectorAll('[data-login-consent-required]')
      if (!required.length) return false
      for (var i = 0; i < required.length; i++) {
        if (!required[i].checked || required[i].dataset.policyRead !== 'true') return false
      }
      return true
    }

    readError(input) {
      var key = input.getAttribute('data-login-consent-required')
      return key ? this.querySelector('[data-login-consent-error="' + key + '"]') : null
    }

    showReadError(input, show) {
      var error = this.readError(input)
      if (!error) return
      if (show) error.textContent = this.dataset.readError || ''
      error.hidden = !show
    }

    onPolicyLinkClick(event) {
      var target = event.target
      var link = target && target.closest ? target.closest('a[href]') : null
      if (!link || !this.contains(link)) return
      var label = link.closest('label')
      var input = label ? label.querySelector('[data-login-consent-required]') : null
      if (!input) return

      input.dataset.policyRead = 'true'
      this.showReadError(input, false)
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return

      event.preventDefault()
      event.stopPropagation()
      if (window.vwAydinlatmaPopup) window.vwAydinlatmaPopup.open(link.href)
    }

    bindReadFirst(input) {
      var label = input.closest('label')
      var link = label ? label.querySelector('a[href]') : null
      if (!link) {
        input.dataset.policyRead = 'true'
        return
      }

      var self = this
      input.addEventListener('click', function (event) {
        if (input.dataset.policyRead === 'true') return
        event.preventDefault()
        input.checked = false
        self.showReadError(input, true)
      })

      input.addEventListener('change', function () {
        if (input.dataset.policyRead === 'true' || !input.checked) return
        input.checked = false
        self.showReadError(input, true)
        self.onChange()
      })
    }

    onChange() {
      var button = this.querySelector('[data-login-consent-confirm]')
      if (!button) return
      button.disabled = !this.hasRequired()
    }

    isGatedLink(link) {
      if (!link || link.closest('login-consent-popup')) return false
      if (link.hasAttribute('data-login-consent')) return true
      var href = link.getAttribute('href')
      if (!href || href.charAt(0) === '#') return false
      if (isLoginHref(href)) return true
      var url = pathOf(href)
      if (!url) return false
      if (isAccountEntry(url)) return true
      var account = pathOf(this.accountUrl)
      var login = pathOf(this.loginUrl)
      if (account && url.origin === account.origin && normalizePath(url.pathname) === normalizePath(account.pathname)) return true
      if (login && url.origin === login.origin && normalizePath(url.pathname) === normalizePath(login.pathname)) return true
      return false
    }

    onDocumentClick(event) {
      if (event.defaultPrevented) return
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null
      if (!this.isGatedLink(link)) return
      event.preventDefault()
      event.stopPropagation()
      this.pendingUrl = loginUrlFor(link.href)
      this.blockingLogin = false
      this.open()
    }

    onKeyDown(event) {
      if (event.defaultPrevented) return
      if (window.vwAydinlatmaPopup && window.vwAydinlatmaPopup.isOpen()) return
      if (event.key === 'Escape') {
        this.onDismiss()
        return
      }
      if (event.key !== 'Tab' || !this.isOpen) return
      var focusable = this.querySelectorAll('a[href], input, button:not([disabled])')
      if (!focusable.length) return
      var first = focusable[0]
      var last = focusable[focusable.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }

    onRequired(event) {
      if (this.designMode) return
      var detail = event.detail || {}
      this.pendingUrl = loginUrlFor(detail.loginUrl || this.loginUrl)
      this.blockingLogin = true
      this.open()
    }

    onSectionSelect(event) {
      if (event.detail && event.detail.sectionId === this.sectionId) this.open()
    }

    onSectionDeselect(event) {
      if (event.detail && event.detail.sectionId === this.sectionId) this.close()
    }

    open() {
      if (this.isOpen) return
      this.isOpen = true
      this.hidden = false
      lockPageScroll()
      document.addEventListener('keydown', this.onKeyDown)
      var dialog = this.querySelector('.login-consent__dialog')
      if (dialog) dialog.focus()
    }

    close() {
      if (!this.isOpen) return
      this.isOpen = false
      this.hidden = true
      unlockPageScroll()
      document.removeEventListener('keydown', this.onKeyDown)
    }

    onDismiss() {
      var blocking = this.blockingLogin && !this.confirmed
      this.pendingUrl = ''
      this.close()
      if (blocking && !this.designMode) {
        window.location.href = this.homeUrl
      }
    }

    onConfirm() {
      if (!this.hasRequired()) return
      if (this.designMode) {
        this.confirmed = true
        this.close()
        return
      }

      writeStorage(PENDING_KEY, JSON.stringify({
        privacy_accepted: true,
        terms_accepted: true,
        last_consented_at: new Date().toISOString(),
        source: 'login_popup'
      }))
      removeStorage(VISIT_KEY)
      deleteCookie(LEGACY_COOKIE)
      this.confirmed = true

      var nextUrl = loginUrlFor(this.pendingUrl)
      this.pendingUrl = ''
      this.blockingLogin = false
      this.close()
      if (nextUrl) window.location.href = nextUrl
    }
  }

  function consentReturnPage() {
    return document.querySelector('.login-consent-return')
  }

  var savedConsentReturnPath = afterLoginReturnPath()
  var consentReturnNode = consentReturnPage()
  if (consentReturnNode && savedConsentReturnPath && consentReturnNode.dataset.designMode !== 'true') {
    var consentReturnHome = consentReturnNode.getAttribute('data-home-url') || '/'
    history.replaceState({}, '', consentReturnHome)
  }

  deleteCookie(LEGACY_COOKIE)
  removeStorage(VISIT_KEY)
  bindLogout()
  Promise.resolve(flushPending()).then(function () {
    var nextPath = savedConsentReturnPath
    var config = readConfig()
    if (!nextPath || !config || !config.loggedIn) return
    window.location.replace(nextPath)
  })

  if (!customElements.get('login-consent-popup')) {
    customElements.define('login-consent-popup', LoginConsentPopup)
  }
})()
